import { render, staticRenderFns } from "./singleShopSplit.vue?vue&type=template&id=0b9d8160&scoped=true"
import script from "./singleShopSplit.vue?vue&type=script&lang=js"
export * from "./singleShopSplit.vue?vue&type=script&lang=js"
import style0 from "./singleShopSplit.vue?vue&type=style&index=0&id=0b9d8160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9d8160",
  null
  
)

export default component.exports